<template>
  <v-app>
    <v-main>
      <router-view style="min-height:100%"></router-view>
    </v-main>
  </v-app>
</template>

<script>


export default {

  data: () => ({
    //
  }),
};
</script>
